// @flow

import _ from 'lodash';
import ko from 'rgs-knockout';

import server from 'server2';

import ObservableMap from 'observable-map';
import { ObservableBusy } from 'observable-busy';

import type {
	Observable,
	ObservableArray,
} from 'rgs-knockout';


export type VehicleMakerModelSelectComponentParams = {
	vehicleMakersMap: ObservableMap,
	vehicleModelsMap: ObservableMap,
	vehicleMakerId: Observable<number>,
	vehicleModelId: Observable<number>,
	busy: ObservableBusy,
}

export default class VehicleMakerModelSelectViewModel {
	_params: VehicleMakerModelSelectComponentParams
	_innerBusy: ObservableBusy
	_vehicleMakerOptions: ObservableArray
	_vehicleModelOptions: ObservableArray
	_vehicleMakerId: Observable<number>
	_vehicleModelId: Observable<number>

	constructor (params: VehicleMakerModelSelectComponentParams) {
		params = _.defaultsDeep({}, params, {
			vehicleMakersMap: undefined,
			vehicleModelsMap: undefined,
			vehicleMakerId: ko.observable(),
			vehicleModelId: ko.observable(),
			busy: undefined,
		});

		this._params = params;

		this._innerBusy = new ObservableBusy();

		this._vehicleMakerOptions = ko.observableArray([]);
		this._vehicleModelOptions = ko.observableArray([]);

		this._getMakers();

		this._params.vehicleMakerId.subscribe(v => {
			if (!v) {
				this._vehicleModelOptions([]);
				return;
			}
			this._getModelsByMakerId(v);
		});

	}

	_getMakers () {
		const getData = async () => {
			const { responseJSON } = await server.any.api.get(
				[
					'dictionary',
					'makers',
				]
			);
			this._vehicleMakerOptions(responseJSON);
			this._addRecordsToDictionary(this._params.vehicleMakersMap, responseJSON);
		};

		const promise = getData();

		this._innerBusy.add(promise);
		if (this._params.busy) {
			this._params.busy.add(promise);
		}
	}

	_getModelsByMakerId (id: number) {
		const getData = async () => {
			const { responseJSON } = await server.any.api.get(
				[
					'dictionary',
					'models',
				],
				{
					query: {
						makerId: id,
						allCategories: true,
					},
				}
			);
			this._vehicleModelOptions(responseJSON);
			this._addRecordsToDictionary(this._params.vehicleModelsMap, responseJSON);
		};

		const promise = getData();

		this._innerBusy.add(promise);
		if (this._params.busy) {
			this._params.busy.add(promise);
		}
	}

	_addRecordsToDictionary (dictionary: ObservableMap, data: Array<Object>) {
		if (!dictionary) {
			return;
		}

		_.each(data, record => {
			if (dictionary.has(record.name) && dictionary.has(record.value)) {
				return;
			}
			dictionary.bisetAbsent(record.name, record.value, true);
		});
		dictionary.notify();
	}
}